module.exports = __webpack_public_path__ + "img/refresh.9992dffc.svg";